// @ts-nocheck
import { refreshSession } from "../auth/session";
import { mapState } from "../map/state";
import { update } from "../map/camera";
import { backendReadyPromise } from "../map/data-sync";
import { getBrowserCookie, deleteBrowserCookie } from "../utils/cookies";
import { openPethernityThanks } from "./payment-thanks";
import { showToast } from "../components/toast/toast";
import { hasMemorialDeepLinkParams } from "./memorial-deep-link";
import { t } from "../i18n";
import { trackPurchaseOnce } from "../utils/meta-events";
import { META_CHECKOUT_CURRENCY, META_CHECKOUT_VALUE } from "../utils/meta-checkout-value";

declare const lucide: any;

function trackBrowserPurchase(
  pendingHeadstoneId: string | null,
  sessionId: string | null,
  pendingHoleId: string | null,
): void {
  const purchaseEventId = pendingHeadstoneId ?? sessionId;
  if (!purchaseEventId) return;

  trackPurchaseOnce(purchaseEventId, {
    content_ids: pendingHoleId ? [pendingHoleId] : undefined,
    content_type: "product",
    currency: META_CHECKOUT_CURRENCY,
    value: META_CHECKOUT_VALUE,
  });
}

export async function checkPaymentAndCreateGrave() {
  const urlParams = new URLSearchParams(window.location.search);
  const status = urlParams.get("status");
  const sessionId = urlParams.get("session_id");
  const pendingPethernityId =
    getBrowserCookie("pendingPethernityId") || getBrowserCookie("pendingHeadstoneId");

  if (status === "success" || sessionId) {
    trackBrowserPurchase(pendingPethernityId, sessionId, null);
    deleteBrowserCookie("pendingPethernityId");
    deleteBrowserCookie("pendingHeadstoneId");
    deleteBrowserCookie("pendingHoleId");
    try {
      sessionStorage.removeItem("pendingPethernityCheckout");
    } catch {
      /* ignore */
    }
    window.history.replaceState({}, document.title, window.location.pathname);

    await refreshSession();
    await openPethernityThanks();
  }

  if (status === "canceled" || urlParams.get("canceled") === "true") {
    deleteBrowserCookie("pendingPethernityId");
    deleteBrowserCookie("pendingHeadstoneId");
    deleteBrowserCookie("pendingHoleId");
    showToast(t("payment.canceled"));
    window.history.replaceState({}, document.title, window.location.pathname);
  }
}

export function initStripeReturn(): void {
  if (typeof lucide !== "undefined") {
    lucide.createIcons();
  }

  const urlParams = new URLSearchParams(window.location.search);
  const sessionId = urlParams.get("session_id");
  const isReturningFromStripe =
    sessionId ||
    urlParams.get("status") === "success" ||
    urlParams.get("success") === "true" ||
    urlParams.get("canceled") === "true";

  if (isReturningFromStripe) {
    const timeoutPromise = new Promise<void>((resolve) =>
      setTimeout(resolve, 8000),
    );
    Promise.race([backendReadyPromise, timeoutPromise]).then(() => {
      checkPaymentAndCreateGrave();
    });
  }

  if (!hasMemorialDeepLinkParams(urlParams)) {
    mapState.camX = 0;
    mapState.camY = 0;
    update();
  }
}
